import { SET_DATA_INDICE_QUALIDADE } from '../actions/actionTypes';

const initialState = {
    dataInicial: '',
    dataFinal: '',
};

export const indiceQualidadeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DATA_INDICE_QUALIDADE:
            return {
                ...state,
                dataInicial: action.payload.dataInicial,
                dataFinal: action.payload.dataFinal,
            };
        default:
            return state;
    }
};
